// extracted by mini-css-extract-plugin
export default {"mainInput":"addToDoInfo_mainInput__uAw5W","inputs":"addToDoInfo_inputs__gGOmQ","check":"addToDoInfo_check__NmTjZ"};